import React from "react";
import { usePayments } from "../../../../../hooks/use-payments";
import PaymentTable from "./payment-table";
import { Payments } from "packages/app/src/types";

function PaymentTableHolder({
  payments,
  isLoading,
  error,
}: {
  payments: Payments[];
  isLoading: boolean;
  error: Error | null;
}) {
 
  return (
    <PaymentTable
      className="col-span-full w-[100%]"
      payments={payments}
      error={error}
      isLoading={isLoading}
    />
  );
}

export default PaymentTableHolder;
